import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function ResultsSection() {
  return <section className="bg-[#FAF7F2] py-20 px-4 border-t border-[#e5e0d8]" data-id="element-186">
      <div className="max-w-3xl mx-auto text-center" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-188">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-8" data-id="element-189">
            Lo que vas a lograr en 14 días
          </h2>

          <p className="text-xl md:text-2xl text-[#2D2A26] mb-12" data-id="element-190">
            No te prometo milagros. Te prometo algo mejor:
            <br data-id="element-191" />
            <span className="font-bold text-[#C94040]" data-id="element-192">
              claridad + orden + menos castigos
            </span>
          </p>

          <div className="grid sm:grid-cols-2 gap-6" data-id="element-193">
            {['Vas a saber qué se paga y cuándo', 'Vas a reducir fugas', 'Vas a evitar cargos por atraso', 'Vas a sentir control otra vez'].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-sm flex flex-col items-center justify-center text-center h-full border border-gray-100" data-id="element-194">
                <Sparkles className="w-8 h-8 text-[#1B2A4A] mb-4 opacity-50" data-id="element-195" />
                <p className="text-lg font-medium text-[#2D2A26]" data-id="element-196">{item}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}